import { Box, styled } from '@mui/material';

export const CopyrightStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '0 16px 14px',
  color: theme.palette.colors.label,
  display: 'flex',
  justifyContent: 'space-evenly',
  fontSize: '12px',
  fontWeight: 'bold',
  textAlign: 'center',

  '&:has(#legalWarning)': {
    flexDirection: 'column',
    '& :first-of-type': {
      marginBottom: '8px',
    },
  },
}));
